import React, {Component} from 'react';
import {connect} from 'react-redux';

class SimpleSelect extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div style={this.props.style} id={this.props.configSearch.id} className={this.props.configSearch.collSize}>
                <div className={"form-group"}>
                    <select id={this.props.configSearch.idSelect} className={"form-control select2-form-control"}>
                    </select>
                </div>
            </div>
        );
    }

    componentDidMount() {
        let select = $('#' + this.props.configSearch.idSelect).select2();
        let data = this.props.data;

        select.empty();
        select.select2({
            data: data,
            placeholder: this.props.configSearch.placeHolder,
            minimumResultsForSearch: -1
        });

        //Cargar seleccionados
        if (this.props.configSearch.seleccionado !== undefined && this.props.configSearch.seleccionado !== "") {
            select.val(this.props.configSearch.seleccionado).trigger('change');
        }else{
            select.val(this.props.configSearch.placeHolder).trigger('change');
        }

        const that = this;

        //Observador de modificación.
        select.on("change", (e) => {
            that.props.configSearch.methodChange(select.select2('data').map((element) => {
                return element.text;
            }));
        });
        // select.on('select2:close', function (e) {
        //     that.props.configSearch.methodChange(select.select2('data').map((element) => {
        //         return element.text;
        //     }));
        // });

    }

    componentWillUpdate(nextProps, nextState, nextContext) {

    }

}

//El primer parametro es el mapeo de las props y el segundo las acciones- luego se le coloca que componente se ejecuta
export default SimpleSelect
